import React from 'react';
import classNames from "classnames";

// plugin that creates slider
import nouislider from "nouislider";
import wNumb from "wnumb";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/core components
import Paper from "@material-ui/core/Paper";
import Icon from "@material-ui/core/Icon";
import withStyles from "@material-ui/core/styles/withStyles";

import { withNamespaces } from "react-i18next";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

class LayerConfigPanel extends React.Component {

  componentDidMount() {
    const { years } = this.props;

    this.slider1 = this.refs.slider1;
    this.slider2 = this.refs.slider2;

    nouislider.create(this.slider1, {
        start: this.props.opacity * 100,
        connect: [false, true],
        step: 1,
        range: { min: 0, max: 100 },
        tooltips: false,
        format: wNumb({
          decimals: 0
        }),
        cssPrefix: "noUiText-"

    });
    this.slider1.noUiSlider.on('update', function() {
      if (this.props.onSetOpacity) {
        this.props.onSetOpacity(this.slider1.noUiSlider.get());
        let children = this.slider1.getElementsByClassName('noUiText-handle')
        let value = this.slider1.noUiSlider.get();

        if (children.length > 0) {
          children[0].innerHTML = value;
        }
      }
    }.bind(this))

    let yearSliderOptions = this.buildSliderOptions(years);
    yearSliderOptions.start = this.props.year;
    nouislider.create(this.slider2, yearSliderOptions);

    this.slider2.noUiSlider.on('update', function() {
      if (this.props.onSetYear) {
        this.props.onSetYear(this.slider2.noUiSlider.get());
        let children = this.slider2.getElementsByClassName('noUiText-handle')
        let value = this.slider2.noUiSlider.get();

        if (children.length > 0) {
          children[0].innerHTML = value;
        }
      }
    }.bind(this))

    this.sliderToggleDisabled(years);
  }

  areYearsSame(array1, array2) {
    if (!Array.isArray(array1) && Array.isArray(array2) ) {
      return true;
    }
    return array1.length === array2.length && array1.every(function(value, index) { return value === array2[index]});
  }

  componentDidUpdate(prevProps) {
    const { years } = this.props;
    if (!Array.isArray(years)) {
      return;
    }
    if (this.areYearsSame(prevProps.years, years)) {
      return;
    }
    this.sliderToggleDisabled(years);
  }

  sliderToggleDisabled(years){
    if (years.length >= 2) {

      const oldValue = this.slider2.noUiSlider.get();
      this.slider2.noUiSlider.updateOptions(this.buildSliderOptions(years));
      if (years.indexOf(oldValue) === -1) {
        this.slider2.noUiSlider.set(years[years.length - 1]);
      }
      this.slider2.removeAttribute('disabled');
    } else {
      this.slider2.noUiSlider.updateOptions(this.buildSliderOptions(years));
      this.slider2.setAttribute('disabled', true);
    }
  }

  buildSliderOptions(years) {
    let options = {
      step: 1,
      tooltips: false,
      connect: [false, true], //ignored on update
      cssPrefix: "noUiText-"
    }
    if (years.length >= 2) {
      options.range = { min: 0, max: years.length - 1 };
      options.format = {
        to: function ( value ) {
          return years[value];
        },
        from: function ( value ) {
          return years.indexOf(value);
        }
      }
    } else {
      options.range = { min: 0, max: 2};
      options.format = {
        to: function (value) {
          return years[0];
        },
        from: function(value) {
          return 1;
        }
      }
    }
    return options;
  }

  render() {
    const { classes, t } = this.props;
    return (
        <Paper className={classNames(classes.dropdown, classes.configpanel)}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <span className={classes.noSelect}>{t("map:opacity")}</span>
              <div ref="slider1" className={classNames("slider-primary")} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <span className={classes.noSelect}>{t("map:year")}</span>
              <div ref="slider2" className={classNames("slider-info")} />
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6} sm={6} md={6}>
              <Button round justIcon color="primary" title={t("map:show-description")} onClick = { this.props.onToggleLayerInfo }>
                <Icon>help</Icon>
              </Button>
              </GridItem>
            <GridItem xs={6} sm={6} md={6}>
              <Button round justIcon color="primary"  title={t("map:show-legend")} onClick = { this.props.onToggleLayerLegend }>
                <Icon>grid_on</Icon>
              </Button>
            </GridItem>
          </GridContainer>
        </Paper>
    );
    }
}

export default withNamespaces()(withStyles(mapStyle)(LayerConfigPanel));